<!-- eslint-disable max-len -->
<template>
  <div>
    <div
      v-if="!hideCovidAlert"
      class="corona-info text-teal-darkest px-4 py-3 shadow-md"
      role="alert"
    >
      <div class="flex">
        <div class="w-1/12 self-center corona-info__info-icon">
          <svg
            class="h-6 w-6 text-teal mr-4"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
          >
            <path
              d="M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zm12.73-1.41A8 8 0 1 0 4.34 4.34a8 8 0 0 0 11.32 11.32zM9 11V9h2v6H9v-4zm0-6h2v2H9V5z"
            />
          </svg>
        </div>
        <div class="w-10/12">
          <p class="font-bold">
            {{ $t("pages.corona_info.title") }}
          </p>
          <p class="text-sm corona-info__text">
            {{ $t("pages.corona_info.subtitle") }}
          </p>
          <p
            class="text-sm corona-info__text underline cursor-pointer"
            @click="isDialogVisible = !isDialogVisible"
          >
            {{ $t("pages.corona_info.more") }}
          </p>
        </div>
        <div class="w-1/12 corona-info__close-icon">
          <svg
            class="w-4 cursor-pointer"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            @click="$store.dispatch('app/hideCovidAlert')"
          >
            <path
              d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm4.151 17.943l-4.143-4.102-4.117 4.159-1.833-1.833 4.104-4.157-4.162-4.119 1.833-1.833 4.155 4.102 4.106-4.16 1.849 1.849-4.1 4.141 4.157 4.104-1.849 1.849z"
            />
          </svg>
        </div>
      </div>
    </div>

    <portal to="modals">
      <CoronaModal
        v-if="isDialogVisible"
        @close="isDialogVisible = false"
      ></CoronaModal>
    </portal>
  </div>
</template>

<script>
import { Portal } from "portal-vue";

import { mapGetters } from "vuex";
import CoronaModal from "@/components/modals/CoronaModal";

export default {
  name: "CoronaInfo",
  components: {
    CoronaModal,
    Portal
  },
  data() {
    return {
      isDialogVisible: false
    };
  },
  computed: {
    ...mapGetters("app", {
      hideCovidAlert: "hideCovidAlert"
    })
  }
};
</script>

<style scoped></style>
